export class AppIoCKeys {

    //IoCContainer
    public static IAppIoCContainer: string = 'IAppIoCContainer';

    public static IAppSettings: string = 'IAppSettings';
}
